import React from 'react';
import { Image } from 'react-native';
import iconsMap from '../../../config/icons';
interface ImageIconProps {
	name: keyof typeof iconsMap;
	width?: number;
	height?: number;
	style?: any;
	src?: any;
	color?: string;
}

const ImageIcon = ({
	name,
	width = 20,
	height = 20,
	style,
	src,
	color,
}: ImageIconProps) => {
	return (
		<Image
			source={src || iconsMap[name]}
			fadeDuration={0}
			style={{ width, height, ...(color ? { tintColor: color } : {}), ...style }}
		/>
	);
};

export default ImageIcon;
